import request from "@/utils/request";
export const getCaseList = () => {
    return request.get("/cases/list");
};
export const getCaseById = (id) => {
    return request.get(`/cases/${id}`);
};
export const saveCase = (data) => {
    return request.post("/cases", data);
};
export const updateCase = (id, data) => {
    return request.put(`/cases/${id}`, data);
};
export const deleteCase = (id) => {
    return request.delete(`/cases/${id}`);
};
